import * as Types from '../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateUserGuideMutationVariables = Types.Exact<{
  input: Types.UserGuideRequest;
}>;


export type CreateUserGuideMutation = { __typename?: 'Mutation', createUserGuide: { __typename?: 'UserGuide', userGuideId?: number | null, userGuideNamePhraseId?: string | null, sortOrder?: number | null, insertUser?: string | null, insertDate?: string | null, updateUser?: string | null, updateDate?: string | null } };

export type UpdateUserGuideMutationVariables = Types.Exact<{
  input: Types.UserGuideRequest;
}>;


export type UpdateUserGuideMutation = { __typename?: 'Mutation', updateUserGuide: { __typename?: 'UserGuide', userGuideId?: number | null, userGuideNamePhraseId?: string | null, sortOrder?: number | null, insertUser?: string | null, insertDate?: string | null, updateUser?: string | null, updateDate?: string | null } };

export type DeleteUserGuideMutationVariables = Types.Exact<{
  id: Types.Scalars['Float']['input'];
}>;


export type DeleteUserGuideMutation = { __typename?: 'Mutation', deleteUserGuide: boolean };

export type CreateUserGuideGroupMutationVariables = Types.Exact<{
  input: Types.UserGuideGroupRequest;
}>;


export type CreateUserGuideGroupMutation = { __typename?: 'Mutation', createUserGuideGroup: { __typename?: 'UserGuideGroup', userGuideGroupId?: number | null, userGuideGroupNamePhraseId?: string | null, sortOrder?: number | null, insertUser?: string | null, insertDate?: string | null, updateUser?: string | null, updateDate?: string | null } };

export type UpdateUserGuideGroupMutationVariables = Types.Exact<{
  input: Types.UserGuideGroupRequest;
}>;


export type UpdateUserGuideGroupMutation = { __typename?: 'Mutation', updateUserGuideGroup: { __typename?: 'UserGuideGroup', userGuideGroupId?: number | null, userGuideGroupNamePhraseId?: string | null, sortOrder?: number | null, insertUser?: string | null, insertDate?: string | null, updateUser?: string | null, updateDate?: string | null } };

export type DeleteUserGuideGroupMutationVariables = Types.Exact<{
  id: Types.Scalars['Float']['input'];
}>;


export type DeleteUserGuideGroupMutation = { __typename?: 'Mutation', deleteUserGuideGroup: boolean };

export type UploadUserGuideDocumentMutationVariables = Types.Exact<{
  input: Types.UserGuideDocUploadInput;
}>;


export type UploadUserGuideDocumentMutation = { __typename?: 'Mutation', uploadUserGuideDocument: { __typename?: 'UserGuideBlob', userGuideBlobId?: number | null, language?: string | null, insertUser?: string | null, insertDate?: string | null, updateUser?: string | null, updateDate?: string | null, blob?: { __typename?: 'TFBlobResponse', blobId?: number | null, downloadLink?: string | null, fileName?: string | null, mimeType?: string | null } | null } };


export const CreateUserGuideDocument = gql`
    mutation CreateUserGuide($input: UserGuideRequest!) {
  createUserGuide(input: $input) {
    userGuideId
    userGuideNamePhraseId
    sortOrder
    insertUser
    insertDate
    updateUser
    updateDate
  }
}
    `;
export type CreateUserGuideMutationFn = Apollo.MutationFunction<CreateUserGuideMutation, CreateUserGuideMutationVariables>;

/**
 * __useCreateUserGuideMutation__
 *
 * To run a mutation, you first call `useCreateUserGuideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserGuideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserGuideMutation, { data, loading, error }] = useCreateUserGuideMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserGuideMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserGuideMutation, CreateUserGuideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserGuideMutation, CreateUserGuideMutationVariables>(CreateUserGuideDocument, options);
      }
export type CreateUserGuideMutationHookResult = ReturnType<typeof useCreateUserGuideMutation>;
export type CreateUserGuideMutationResult = Apollo.MutationResult<CreateUserGuideMutation>;
export type CreateUserGuideMutationOptions = Apollo.BaseMutationOptions<CreateUserGuideMutation, CreateUserGuideMutationVariables>;
export const UpdateUserGuideDocument = gql`
    mutation UpdateUserGuide($input: UserGuideRequest!) {
  updateUserGuide(input: $input) {
    userGuideId
    userGuideNamePhraseId
    sortOrder
    insertUser
    insertDate
    updateUser
    updateDate
  }
}
    `;
export type UpdateUserGuideMutationFn = Apollo.MutationFunction<UpdateUserGuideMutation, UpdateUserGuideMutationVariables>;

/**
 * __useUpdateUserGuideMutation__
 *
 * To run a mutation, you first call `useUpdateUserGuideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserGuideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserGuideMutation, { data, loading, error }] = useUpdateUserGuideMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserGuideMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserGuideMutation, UpdateUserGuideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserGuideMutation, UpdateUserGuideMutationVariables>(UpdateUserGuideDocument, options);
      }
export type UpdateUserGuideMutationHookResult = ReturnType<typeof useUpdateUserGuideMutation>;
export type UpdateUserGuideMutationResult = Apollo.MutationResult<UpdateUserGuideMutation>;
export type UpdateUserGuideMutationOptions = Apollo.BaseMutationOptions<UpdateUserGuideMutation, UpdateUserGuideMutationVariables>;
export const DeleteUserGuideDocument = gql`
    mutation DeleteUserGuide($id: Float!) {
  deleteUserGuide(id: $id)
}
    `;
export type DeleteUserGuideMutationFn = Apollo.MutationFunction<DeleteUserGuideMutation, DeleteUserGuideMutationVariables>;

/**
 * __useDeleteUserGuideMutation__
 *
 * To run a mutation, you first call `useDeleteUserGuideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserGuideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserGuideMutation, { data, loading, error }] = useDeleteUserGuideMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserGuideMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserGuideMutation, DeleteUserGuideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserGuideMutation, DeleteUserGuideMutationVariables>(DeleteUserGuideDocument, options);
      }
export type DeleteUserGuideMutationHookResult = ReturnType<typeof useDeleteUserGuideMutation>;
export type DeleteUserGuideMutationResult = Apollo.MutationResult<DeleteUserGuideMutation>;
export type DeleteUserGuideMutationOptions = Apollo.BaseMutationOptions<DeleteUserGuideMutation, DeleteUserGuideMutationVariables>;
export const CreateUserGuideGroupDocument = gql`
    mutation CreateUserGuideGroup($input: UserGuideGroupRequest!) {
  createUserGuideGroup(input: $input) {
    userGuideGroupId
    userGuideGroupNamePhraseId
    sortOrder
    insertUser
    insertDate
    updateUser
    updateDate
  }
}
    `;
export type CreateUserGuideGroupMutationFn = Apollo.MutationFunction<CreateUserGuideGroupMutation, CreateUserGuideGroupMutationVariables>;

/**
 * __useCreateUserGuideGroupMutation__
 *
 * To run a mutation, you first call `useCreateUserGuideGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserGuideGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserGuideGroupMutation, { data, loading, error }] = useCreateUserGuideGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserGuideGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserGuideGroupMutation, CreateUserGuideGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserGuideGroupMutation, CreateUserGuideGroupMutationVariables>(CreateUserGuideGroupDocument, options);
      }
export type CreateUserGuideGroupMutationHookResult = ReturnType<typeof useCreateUserGuideGroupMutation>;
export type CreateUserGuideGroupMutationResult = Apollo.MutationResult<CreateUserGuideGroupMutation>;
export type CreateUserGuideGroupMutationOptions = Apollo.BaseMutationOptions<CreateUserGuideGroupMutation, CreateUserGuideGroupMutationVariables>;
export const UpdateUserGuideGroupDocument = gql`
    mutation UpdateUserGuideGroup($input: UserGuideGroupRequest!) {
  updateUserGuideGroup(input: $input) {
    userGuideGroupId
    userGuideGroupNamePhraseId
    sortOrder
    insertUser
    insertDate
    updateUser
    updateDate
  }
}
    `;
export type UpdateUserGuideGroupMutationFn = Apollo.MutationFunction<UpdateUserGuideGroupMutation, UpdateUserGuideGroupMutationVariables>;

/**
 * __useUpdateUserGuideGroupMutation__
 *
 * To run a mutation, you first call `useUpdateUserGuideGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserGuideGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserGuideGroupMutation, { data, loading, error }] = useUpdateUserGuideGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserGuideGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserGuideGroupMutation, UpdateUserGuideGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserGuideGroupMutation, UpdateUserGuideGroupMutationVariables>(UpdateUserGuideGroupDocument, options);
      }
export type UpdateUserGuideGroupMutationHookResult = ReturnType<typeof useUpdateUserGuideGroupMutation>;
export type UpdateUserGuideGroupMutationResult = Apollo.MutationResult<UpdateUserGuideGroupMutation>;
export type UpdateUserGuideGroupMutationOptions = Apollo.BaseMutationOptions<UpdateUserGuideGroupMutation, UpdateUserGuideGroupMutationVariables>;
export const DeleteUserGuideGroupDocument = gql`
    mutation DeleteUserGuideGroup($id: Float!) {
  deleteUserGuideGroup(id: $id)
}
    `;
export type DeleteUserGuideGroupMutationFn = Apollo.MutationFunction<DeleteUserGuideGroupMutation, DeleteUserGuideGroupMutationVariables>;

/**
 * __useDeleteUserGuideGroupMutation__
 *
 * To run a mutation, you first call `useDeleteUserGuideGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserGuideGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserGuideGroupMutation, { data, loading, error }] = useDeleteUserGuideGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserGuideGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserGuideGroupMutation, DeleteUserGuideGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserGuideGroupMutation, DeleteUserGuideGroupMutationVariables>(DeleteUserGuideGroupDocument, options);
      }
export type DeleteUserGuideGroupMutationHookResult = ReturnType<typeof useDeleteUserGuideGroupMutation>;
export type DeleteUserGuideGroupMutationResult = Apollo.MutationResult<DeleteUserGuideGroupMutation>;
export type DeleteUserGuideGroupMutationOptions = Apollo.BaseMutationOptions<DeleteUserGuideGroupMutation, DeleteUserGuideGroupMutationVariables>;
export const UploadUserGuideDocumentDocument = gql`
    mutation UploadUserGuideDocument($input: UserGuideDocUploadInput!) {
  uploadUserGuideDocument(input: $input) {
    userGuideBlobId
    language
    insertUser
    insertDate
    updateUser
    updateDate
    blob {
      blobId
      downloadLink
      fileName
      mimeType
    }
  }
}
    `;
export type UploadUserGuideDocumentMutationFn = Apollo.MutationFunction<UploadUserGuideDocumentMutation, UploadUserGuideDocumentMutationVariables>;

/**
 * __useUploadUserGuideDocumentMutation__
 *
 * To run a mutation, you first call `useUploadUserGuideDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadUserGuideDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadUserGuideDocumentMutation, { data, loading, error }] = useUploadUserGuideDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadUserGuideDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UploadUserGuideDocumentMutation, UploadUserGuideDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadUserGuideDocumentMutation, UploadUserGuideDocumentMutationVariables>(UploadUserGuideDocumentDocument, options);
      }
export type UploadUserGuideDocumentMutationHookResult = ReturnType<typeof useUploadUserGuideDocumentMutation>;
export type UploadUserGuideDocumentMutationResult = Apollo.MutationResult<UploadUserGuideDocumentMutation>;
export type UploadUserGuideDocumentMutationOptions = Apollo.BaseMutationOptions<UploadUserGuideDocumentMutation, UploadUserGuideDocumentMutationVariables>;